import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { JOBS_PAGE } from 'src/constants';
import TopNavBar from 'src/HomePage/TopNavBar/TopNavBar';
import JobsContent from 'src/Jobs/JobsContent';
import styles from 'src/Jobs/JobsLandingPageStyles';

const JobsLandingPage = (): ReactElement => {
  const classes = styles();
  return (
    <div className={classes.jobsPage}>
      <TopNavBar currentPage={JOBS_PAGE} />
      <div>
        <Typography variant="h2">Jobs</Typography>
      </div>
      <div className={classes.jobsContentContainer}>
        <JobsContent />
      </div>
    </div>
  );
};

export default JobsLandingPage;
